import React from "react";
import { Box, Heading, Text, Image, VStack, HStack, Badge, Divider, Stack } from "@chakra-ui/react";
import parse from "html-react-parser"; // ใช้สำหรับแปลง HTML

// ตัวอย่างข้อมูลข่าว
const newsArticle = {
  title: "วัคซีนปศุสัตว์ใหม่ช่วยลดการแพร่กระจายของโรค",
  subtitle: "นักวิจัยพัฒนาวัคซีนใหม่เพื่อป้องกันการแพร่ระบาดในฟาร์ม",
  content: `<p>นักวิทยาศาสตร์จากสำนักเทคโนโลยีชีวภัณฑ์สัตว์ได้ประกาศความสำเร็จในการพัฒนาวัคซีน<br>
    ที่สามารถช่วยลดการแพร่ระบาดของโรคในปศุสัตว์ได้อย่างมีประสิทธิภาพ ซึ่งวัคซีนใหม่นี้ได้รับการทดสอบแล้ว
    กับสัตว์หลายชนิดและพบว่าช่วยลดอัตราการติดเชื้อได้มากถึง <i>85%</i></p><br>

    <p><b>นอกจากนี้ วัคซีนยังช่วยเพิ่มภูมิคุ้มกันของสัตว์</b> ทำให้มีสุขภาพแข็งแรงขึ้น ลดความสูญเสียทางเศรษฐกิจสำหรับเกษตรกร
    และช่วยให้การควบคุมโรคในฟาร์มเป็นไปได้ง่ายขึ้น อีกทั้งยังสามารถลดการใช้ยาปฏิชีวนะ ซึ่งเป็นประเด็นสำคัญในปัจจุบัน</p>

    <p>นักวิจัยเปิดเผยว่า <u>การพัฒนาวัคซีนนี้ใช้เทคโนโลยีชีวภาพที่ทันสมัย</u> ซึ่งสามารถกระตุ้นระบบภูมิคุ้มกันของสัตว์ให้ตอบสนอง
    ต่อเชื้อโรคได้อย่างรวดเร็ว นอกจากนี้ยังมีการพัฒนากระบวนการผลิตที่สามารถขยายขนาดเพื่อรองรับการใช้งานในวงกว้าง</p><br>

    <p>วัคซีนนี้ได้รับการสนับสนุนจากภาครัฐและองค์กรด้านปศุสัตว์ ซึ่งได้จัดตั้งกองทุนวิจัยเพื่อส่งเสริมการพัฒนาวัคซีนในระยะยาว
    มีการวางแผนทดลองภาคสนามเพิ่มเติมในหลายพื้นที่ทั่วประเทศ เพื่อให้แน่ใจว่าวัคซีนนี้สามารถป้องกันการแพร่ระบาดของโรคได้จริง
    และไม่มีผลกระทบที่เป็นอันตรายต่อสุขภาพของสัตว์</p><br>

    <p>ในอนาคต นักวิทยาศาสตร์ตั้งเป้าที่จะพัฒนาวัคซีนรุ่นใหม่ที่สามารถให้ภูมิคุ้มกันได้ยาวนานขึ้น และลดต้นทุนการผลิต
    เพื่อให้เกษตรกรสามารถเข้าถึงวัคซีนได้ในราคาที่เหมาะสม ซึ่งจะช่วยสร้างความมั่นคงด้านปศุสัตว์ และลดผลกระทบจากโรคระบาด</p><br>

    <p>ด้วยความก้าวหน้าทางเทคโนโลยีชีวภาพในปัจจุบัน ทำให้ความหวังในการควบคุมโรคปศุสัตว์เป็นจริงมากขึ้น
    ผู้เชี่ยวชาญคาดการณ์ว่าในอีกไม่กี่ปีข้างหน้า วัคซีนปศุสัตว์รุ่นใหม่จะสามารถเปลี่ยนแปลงแนวทางการจัดการสุขภาพสัตว์
    และช่วยสร้างมาตรฐานใหม่ในอุตสาหกรรมปศุสัตว์ระดับโลก</p>` ,
  date: "10 มีนาคม 2025",
  author: "ดร. สมชาย พัฒนาสัตว์",
  tags: ["วัคซีน", "ปศุสัตว์", "สุขภาพสัตว์"],
  images: ["/n1.png", "/n2.png", "/n3.png", ] // รายการภาพข่าว
};

const NewsDetailPage = () => {
  return (
    <Box maxW="1000px" mx="auto" p={6} bg="white" borderRadius="lg" boxShadow="lg">
      <HStack align="start" spacing={6}>
        
        {/* เนื้อหาข่าว */}
        <Box flex="1">
          <VStack align="start" spacing={2}>
            <Heading size="xl">{newsArticle.title}</Heading>
            <Heading size="md" color="gray.600">{newsArticle.subtitle}</Heading>
            <Divider />
          </VStack>

          {/* ข้อมูลผู้เขียน & วันที่ */}
          <HStack justify="space-between" w="full" mt={4} color="gray.500">
            <Text fontSize="md">โดย {newsArticle.author}</Text>
            <Text fontSize="md">{newsArticle.date}</Text>
          </HStack>

          {/* เนื้อหาข่าว */}
          <Text fontSize="lg" mt={4} lineHeight="tall">{parse(newsArticle.content)}</Text>

          {/* แท็กข่าว */}
          <HStack mt={6}>
            {newsArticle.tags.map((tag, index) => (
              <Badge key={index} colorScheme="blue" px={3} py={1} borderRadius="full">
                {tag}
              </Badge>
            ))}
          </HStack>
        </Box>
        {/* ภาพประกอบข่าวเรียงแนวตั้ง */}
        <VStack spacing={5} align="start" ml={5}>
          {newsArticle.images.map((image, index) => (
            <Image key={index} src={image} alt={`ข่าว-${index + 1}`} borderRadius="lg" w="250px" />
          ))}
        </VStack>
      </HStack>
    </Box>
  );
};

export default NewsDetailPage;
